import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {OutsideClickDirective} from '../../../../../_directives/outside-click.directive';
import {SpriteVersionDirective} from '../../../../../_directives/spriteVersionDirective';
import {CompanySwitcherComponent} from './company-switcher.component';

@NgModule({
  imports: [
    CompanySwitcherComponent,
    CommonModule,
    NgScrollbarModule,
    OutsideClickDirective,
    SpriteVersionDirective
  ],
  exports: [CompanySwitcherComponent]
})
export class CompanySwitcherModule {
}
